export const billingAmountAction = {
  selectBillingAmount: (state, action) => {
    state.selectedBillingAmount = action.payload;
  },
};
